function getNewPageURL(pageType: string, device: string, url: string) {
   const location = '/' + pageType + '/';
   if (pageType == 'guide') {
      device = encodeURIComponent(device.trim());
      return location + 'new/device/' + device;
   } else {
      return url;
   }
}
export { getNewPageURL };
